import SwiperInit from './parts/swiperInit'

document.addEventListener('DOMContentLoaded', () => {
  const relatedCardsElems = document.querySelectorAll('.related-cards-swiper')
  let relatedPerView
  Array.prototype.forEach.call(relatedCardsElems, (relatedElem) => {
    const dataCount = parseInt(relatedElem.getAttribute('data-count'))
    const relatedCardsSwiper = new SwiperInit({
      selector: relatedElem,
      manualLoop: true,
      spaceBetween: 32,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
      slidesPerView: dataCount,
      breakPoints: {
        280: {
          centeredSlides: true,
          slidesPerView: 1.2, 
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        768: {
          centeredSlides: true,
          slidesPerView: 1.8, 
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        992: {
          centeredSlides: false,
          slidesPerView: 2.2,
          spaceBetween: 20,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1200: {
          slidesPerView: dataCount, 
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        }
      }
    })
  })
})